import React, { useEffect, useState } from "react";

const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiempre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const useDateRange = (props) => {
  const { range, setRange } = props;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!range) {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1);
      const end = new Date(now.getFullYear(), now.getMonth());

      setRange({
        value: `${start.getFullYear()}-${start.getMonth()}`,
        label: months[start.getMonth()] + " " + start.getFullYear(),
        start: start,
        end: end,
      });
    }
  }, [range, setRange]);

  useEffect(() => {
    const now = new Date();
    let options = [];
    for (let i = 0; i < 12; i += 1) {
      const start = new Date(now.getFullYear(), now.getMonth() - (i + 1));
      const end = new Date(now.getFullYear(), now.getMonth() - i);

      options.push({
        value: `${start.getFullYear()}-${start.getMonth()}`,
        label: months[start.getMonth()] + " " + start.getFullYear(),
        start: start,
        end: end,
      });
    }

    setOptions(options);
  }, []);

  const handleSelectChange = (event) => {
    let index = 0;
    options.forEach((option, it) => {
      if (option.value === event.target.value) {
        index = it;
      }
    });

    setRange(options[index]);
  };

  return {
    options,
    range,
    setRange,
    handleSelectChange,
  };
};

const DateRange = (props) => {
  const { range, options, handleSelectChange } = useDateRange(props);

  return (
    <div className="level">
      <div className="level-left">
        <div className="level-item">
          <p className="is-size-5">Rango de reporte</p>
        </div>
        <div className="level-item">
          <div className="select">
            <select
              value={range ? range.value : ""}
              onChange={handleSelectChange}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRange;
